import { lazy } from "react";

export { default as Loading } from "./Loading";
export const Passport = lazy(() => import("./Passport"));
export const DriversLicenseFront = lazy(() => import("./DriversLicenseFront"));
export const DriversLicenseBack = lazy(() => import("./DriversLicenseBack"));
export const IdentityCardFront = lazy(() => import("./IdentityCardFront"));
export const IdentityCardBack = lazy(() => import("./IdentityCardBack"));
export const ResidencePermitFront = lazy(() => import("./ResidencePermitFront"));
export const ResidencePermitBack = lazy(() => import("./ResidencePermitBack"));
